import { render } from "./sel-button.vue?vue&type=template&id=5a6c7441&scoped=true"
import script from "./sel-button.vue?vue&type=script&lang=js"
export * from "./sel-button.vue?vue&type=script&lang=js"

import "./sel-button.vue?vue&type=style&index=0&id=5a6c7441&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6c7441"]])

export default __exports__